import axios, { AxiosResponse } from "axios";

// Define the function with appropriate types for parameters and return type
export const fetchUserRole = async (requestedEmail: string | null, isid: string): Promise<AxiosResponse<any> | null> => {
    try {
        const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/fetchUserRole`;
        const response = await axios.post(apiUrl, null, {
            headers: {
                Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
                "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY
            },
            params: {
                email: requestedEmail ?? "",
                isid, // Use requestedEmail or an empty string
            }
        });

        // Return the response for further handling
        return response;
    } catch (err) {
        // Handle errors
        return null; // Return null in case of an error
    }
};
